if (typeof ProductCardVariants !== 'function') {
  class ProductCardVariants extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', this.onVariantClick.bind(this));
    }

    onVariantClick(event) {
      const button = event.target.closest('[data-hf-card-variant]');
      if (!button || button.disabled || !this.contains(button)) return;

      const variantId = button.dataset.variantId;
      const variantInput = this.querySelector('[data-hf-card-variant-input]');
      const productCard = this.closest('[data-js-product-item]');
      const priceContainer = productCard?.querySelector('[data-hf-product-card-price] .remove-line-height-space');
      const priceTemplate = [...this.querySelectorAll('[data-hf-variant-price-template]')]
        .find(template => template.dataset.hfVariantPriceTemplate === variantId);
      const addButton = this.querySelector('[data-hf-card-add-button]');

      this.querySelectorAll('[data-hf-card-variant]').forEach(option => {
        const isSelected = option === button;
        option.classList.toggle('is-selected', isSelected);
        option.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });

      if (variantInput) {
        variantInput.value = variantId;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (priceContainer && priceTemplate) {
        priceContainer.innerHTML = priceTemplate.innerHTML;
      }

      if (addButton) {
        addButton.setAttribute('aria-label', `Adicionar ao carrinho: ${button.dataset.variantTitle}`);
      }
    }
  }

  customElements.define('product-card-variants', ProductCardVariants);
}

document.addEventListener('click', event => {
  const continueLink = event.target.closest('.cart-drawer__continue');
  if (!continueLink) return;

  const cartDrawer = continueLink.closest('sidebar-drawer');
  if (cartDrawer && typeof cartDrawer.hide === 'function') {
    event.preventDefault();
    cartDrawer.hide();
  }
}, true);
